var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"establish_team"},[_c('form-create',{ref:"form",attrs:{"inline":false,"label-width":"120px","label-position":'right',"components":[
        {
          name: 'el-row',
          components: [
            {
              name: 'el-col',
              props: { span: 16 },
              components: [
                {
                  name: 'el-row',
                  components: [
                    {
                      name: 'el-col',
                      props: { span: 24 },
                      components: [
                        {
                          name: 'form-item',
                          props: {
                            prop: 'name',
                            label: '团队名称',
                            required: true,
                            rules: [
                              {
                                required: true,
                                message: '请输入团队名称',
                                trigger: 'change',
                              },
                            ],
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  name: 'el-col',
                  props: { span: 24 },
                  components: [
                    {
                      name: 'form-item',
                      props: {
                        prop: 'province_id',
                        required: true,
                        label: '地域',
                        type: 'select',
                        data: {
                          name: 'user_group',
                          keys: 'province_id',
                          isAll: false,
                        },
                        rules: [
                          {
                            required: true,
                            message: '请选择地域',
                            trigger: 'change',
                          },
                        ],
                      },
                    },
                  ],
                },
                {
                  name: 'el-col',
                  props: { span: 24 },
                  components: [
                    {
                      name: 'form-item',
                      props: {
                        prop: 'type',
                        required: true,
                        label: '类别',
                        type: 'select',
                        data: {
                          name: 'user_group',
                          keys: 'type',
                          isAll: false,
                        },
                        filterable: false,
                        rules: [
                          {
                            required: true,
                            message: '请选择地域',
                            trigger: 'change',
                          },
                        ],
                      },
                    },
                  ],
                },
              ],
            },

            {
              name: 'el-col',
              props: { span: 8 },
              components: [
                {
                  name: 'form-item',
                  props: {
                    prop: 'logo',
                    label: '团队logo',
                    required: true,
                    type: 'upload',
                    accept: 'image/jpeg',
                    notice: '请上传700*700尺寸的图片',
                    rules: [
                      {
                        required: true,
                        message: '请选择团队logo',
                        trigger: 'change',
                      },
                    ],
                  },
                  slots: { content: 'imageLogo' },
                },
              ],
            },
          ],
        },

        // {
        //   name: 'form-item',
        //   props: {
        //     prop: 'name',
        //     label: '团队名称',
        //     required: true,
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入团队名称',
        //         trigger: 'change',
        //       },
        //     ],
        //   },
        // },
        // {
        //   name: 'el-row',
        //   components: [
        //     {
        //       name: 'el-col',
        //       props: { span: 8 },
        //       components: [
        //         {
        //           name: 'form-item',
        //           props: {
        //             prop: 'province_id',
        //             required: true,
        //             label: '地域',
        //             type: 'select',
        //             data: {
        //               name: 'user_group',
        //               keys: 'province_id',
        //               isAll: false,
        //             },
        //             rules: [
        //               {
        //                 required: true,
        //                 message: '请选择地域',
        //                 trigger: 'change',
        //               },
        //             ],
        //           },
        //         },
        //       ],
        //     },
        //     {
        //       name: 'el-col',
        //       props: { span: 8 },
        //       components: [
        //         {
        //           name: 'form-item',
        //           props: {
        //             prop: 'type',
        //             required: true,
        //             label: '类别',
        //             type: 'select',
        //             data: { name: 'user_group', keys: 'type', isAll: false },
        //             filterable: false,
        //             rules: [
        //               {
        //                 required: true,
        //                 message: '请选择地域',
        //                 trigger: 'change',
        //               },
        //             ],
        //           },
        //         },
        //       ],
        //     },
        //     {
        //       name: 'el-col',
        //       props: { span: 8 },
        //       components: [
        //         {
        //           name: 'form-item',
        //           props: {
        //             prop: 'logo',
        //             label: '团队logo',
        //             required: true,
        //             type: 'upload',
        //             accept: 'image/jpeg',
        //             notice: '请上传700*700尺寸的图片',
        //             rules: [
        //               {
        //                 required: true,
        //                 message: '请选择团队logo',
        //                 trigger: 'change',
        //               },
        //             ],
        //           },
        //           slots: { content: 'imageLogo' },
        //         },
        //       ],
        //     },
        //   ],
        // },
        {
          name: 'el-row',
          components: [
            {
              name: 'el-col',
              props: { span: 12 },
              components: [
                {
                  name: 'form-item',
                  hidden: _vm.cid == 0,
                  props: {
                    prop: 'is_copy_member',
                    label: '是否复制原团队成员',
                    labelWidth: '180px',
                    defaultValue: 1,
                    type: 'radio',
                    data: [
                      { label: '是', value: 1 },
                      { label: '否', value: 0 },
                    ],
                  },
                  callback(c) {
                    c.props.hidden = _vm.isEdit;
                  },
                },
              ],
            },
            {
              name: 'el-col',
              props: { span: 12 },
              components: [
                {
                  name: 'form-item',
                  hidden: _vm.cid == 0,
                  props: {
                    prop: 'is_copy_datum',
                    label: '是否复制原团队题目题单',
                    labelWidth: '180px',
                    type: 'radio',
                    defaultValue: 1,
                    data: [
                      { label: '是', value: 1 },
                      { label: '否', value: 0 },
                    ],
                  },
                  callback(c) {
                    c.props.hidden = _vm.isEdit;
                  },
                },
              ],
            },
          ],
        },
        {
          name: 'form-item',
          props: {
            prop: 'description',
            label: '团队介绍',
            type: 'editor',
            required: true,
            editorConfig: {
              module: 'default',
              initialFrameHeight: 100,
              maximumWords: 2000,
            },
            style: { position: 'relative', zIndex: 0 },
          },
        },

        {
          name: 'el-row',
          components: [
            // {
            //   name: 'el-col',
            //   props: { span: 12 },
            //   components: [
            //     {
            //       name: 'form-item',
            //       props: {
            //         prop: 'cover',
            //         label: '团队封面',
            //         required: true,
            //         type: 'upload',
            //         accept: 'image/jpeg',
            //         notice: '请上传700*700尺寸的图片',
            //         rules: [
            //           {
            //             required: true,
            //             message: '请选择团队封面',
            //             trigger: 'change',
            //           },
            //         ],
            //       },
            //       slots: { content: 'imageUrl' },
            //     },
            //   ],
            // },
            // {
            //   name: 'el-col',
            //   props: { span: 12 },
            //   components: [
            //     {
            //       name: 'form-item',
            //       props: {
            //         prop: 'logo',
            //         label: '团队logo',
            //         required: true,
            //         type: 'upload',
            //         accept: 'image/jpeg',
            //         notice: '请上传700*700尺寸的图片',
            //         rules: [
            //           {
            //             required: true,
            //             message: '请选择团队logo',
            //             trigger: 'change',
            //           },
            //         ],
            //       },
            //       slots: { content: 'imageLogo' },
            //     },
            //   ],
            // },
          ],
        },
      ]},on:{"update":_vm.handleFormUpdate},scopedSlots:_vm._u([{key:"imageUrl",fn:function({ fileList }){return [((fileList || []).length >= 1)?_c('el-image',{staticClass:"avatar",attrs:{"fit":"contain","src":fileList[0].url}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"},[_c('span',[_vm._v("封面上传")])])]}},{key:"imageLogo",fn:function({ fileList }){return [((fileList || []).length >= 1)?_c('el-image',{staticClass:"avatar",attrs:{"fit":"contain","src":fileList[0].url}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"},[_c('span',[_vm._v("logo上传")])])]}}]),model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),(_vm.isEdit)?_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('span',{staticStyle:{"width":"110px","text-align":"right","font-size":"14px"}},[_vm._v("成员列表")]),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.memberDataLoading),expression:"memberDataLoading"}],staticStyle:{"width":"100%","margin-left":"10px"},attrs:{"data":_vm.memberData,"row-style":{ height: '0' },"cell-style":{ padding: '6px' },"header-cell-style":{
            height: '50',
            padding: '4px',
            background: '#F9F9F9',
          }}},[_c('el-table-column',{attrs:{"prop":"user_id","align":"center","label":"ID"}}),_c('el-table-column',{attrs:{"prop":"realname","align":"center","label":"成员姓名"}}),_c('el-table-column',{attrs:{"prop":"sex","align":"center","label":"性别"}}),_c('el-table-column',{attrs:{"prop":"identity","align":"center","label":"身份"}}),_c('el-table-column',{attrs:{"prop":"phone","align":"center","label":"手机号"}}),_c('el-table-column',{attrs:{"align":"center","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.identity != '管理员(创建人)')?_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.setManager(scope.row)}}},[_vm._v(" 修改成员身份 ")]):_vm._e()]}}],null,false,3370916331)})],1)],1),_c('div',{staticClass:"pagination",staticStyle:{"margin-top":"20px"}},[_c('el-pagination',{attrs:{"background":"","layout":"total, sizes, prev, pager, next","total":_vm.memberTotal,"page-size":_vm.memberpageSize,"current-page":_vm.memberpage},on:{"current-change":_vm.membercurrentChange,"size-change":_vm.memberSizeChange}})],1),_c('div',{staticStyle:{"display":"flex","margin-top":"20px"}},[_c('span',{staticStyle:{"width":"110px","text-align":"right","font-size":"14px"}},[_vm._v("关注团队列表")]),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.focusTeamDataLoading),expression:"focusTeamDataLoading"}],staticStyle:{"width":"100%","margin-left":"10px"},attrs:{"data":_vm.focusTeamData,"row-style":{ height: '0' },"cell-style":{ padding: '6px' },"header-cell-style":{
            height: '50',
            padding: '4px',
            background: '#F9F9F9',
          }}},[_c('el-table-column',{attrs:{"prop":"name","align":"center","label":"团队名称"}}),_c('el-table-column',{attrs:{"prop":"user_realname","align":"center","label":"创建人"}}),_c('el-table-column',{attrs:{"prop":"manager_user_count","align":"center","label":"管理员人数"}}),_c('el-table-column',{attrs:{"prop":"member_user_count","align":"center","label":"成员人数"}}),_c('el-table-column',{attrs:{"prop":"create_time","align":"center","label":"创建时间"}}),_c('el-table-column',{attrs:{"prop":"f_valid_s","align":"center","label":"状态"}})],1)],1),_c('div',{staticClass:"pagination",staticStyle:{"margin-top":"20px"}},[_c('el-pagination',{attrs:{"background":"","layout":"total, sizes, prev, pager, next","total":_vm.teamTotal,"page-size":_vm.teampageSize,"current-page":_vm.teampage},on:{"current-change":_vm.teamcurrentChange,"size-change":_vm.teamSizeChange}})],1)]):_vm._e()],1),_c('div',{staticClass:"btn"},[(_vm.cid && _vm.teamInfo.identity == '创建人')?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addTeam}},[_vm._v("添加关注团队")]):_vm._e(),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.clickAdd(false)}}},[_vm._v("添加成员")]),(_vm.cid)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.clickAdd(true)}}},[_vm._v("保存")]):_vm._e(),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$routerGo(-1, { path: '/team' })}}},[_vm._v("取消")])],1),_c('el-dialog',{staticClass:"dialogVisible",attrs:{"title":"","visible":_vm.dialogVisible,"width":"70%","show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("添加团队成员")]),_c('i',{staticClass:"el-icon-circle-close",on:{"click":_vm.cancel}})]),_c('div',{staticClass:"body"},[_c('el-row',{staticClass:"body-item",attrs:{"gutter":20}},[_c('el-col',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"span":8}},[_c('div',{staticStyle:{"white-space":"nowrap","margin-right":"20px"}},[_vm._v("选择团队")]),_c('el-select',{staticStyle:{"width":"60%"},attrs:{"filterable":"","remote":"","remote-method":_vm.inputChange,"placeholder":"请搜索","clearable":""},on:{"change":_vm.getMemberList},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}},_vm._l((_vm.teamList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.name,"value":item.id}})}),1)],1),_c('el-col',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"span":8}},[_c('div',{staticClass:"subject",staticStyle:{"margin-right":"20px"}},[_vm._v("选择成员")]),_c('el-input',{staticStyle:{"width":"60%"},attrs:{"clearable":"","placeholder":"请输入学生姓名或手机号"},on:{"change":_vm.search},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.search.apply(null, arguments)}},model:{value:(_vm.searchStu),callback:function ($$v) {_vm.searchStu=$$v},expression:"searchStu"}})],1),_c('el-col',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"span":8}},[_c('div',{staticStyle:{"font-size":"14px"}},[_vm._v("导入成员：")]),_c('div',{staticStyle:{"margin-top":"-6px"}},[_c('el-upload',{ref:"upload",attrs:{"action":"#","before-upload":_vm.beforeUpload,"on-error":_vm.onError}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1),_c('div',{staticClass:"filename"},[_vm._v(_vm._s(_vm.filename))])],1),_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.$tool.fileResponse(
                '',
                { file: 'import/white_user.xlsx' },
                '导入模板.xlsx'
              )}}},[_vm._v("下载导入模板")])],1)],1),_c('div',{staticStyle:{"margin-bottom":"20px"}},[(_vm.nloginsList.length > 0)?_c('div',{staticStyle:{"font-size":"14px","color":"red"}},[_vm._v(" 表格内以下学生未注册："+_vm._s(_vm.nloginsList.join("、"))+",请确认后添加！ ")]):_vm._e(),(_vm.dupsList.length > 0)?_c('div',{staticStyle:{"font-size":"14px","color":"red"}},[_vm._v(" 表格内以下学生重名："+_vm._s(_vm.dupsList.join("、"))+",请确认后添加！ ")]):_vm._e()]),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.stuLoading),expression:"stuLoading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"stripe":"","type":"selection","data":_vm.tableData,"tooltip-effect":"dark","row-key":(row) => row.id},on:{"selection-change":_vm.selectPeople}},[_c('el-table-column',{attrs:{"type":"selection","align":"center","reserve-selection":true}}),_c('el-table-column',{attrs:{"label":"ID","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.id))]}}])}),_c('el-table-column',{attrs:{"prop":"realname","label":"成员","align":"center"}}),_c('el-table-column',{attrs:{"prop":"phone","label":"手机号","align":"center"}}),_c('el-table-column',{attrs:{"prop":"sex","label":"性别","align":"center"}})],1),_c('div',{staticClass:"select"},[_vm._v("已选择："+_vm._s(_vm.selectPeopleList.length))]),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.total,"page-size":_vm.pageSize,"current-page":_vm.page,"hide-on-single-page":true},on:{"current-change":function($event){_vm.getMemberList((_vm.page = $event))}}})],1)],1),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"save",on:{"click":function($event){return _vm.determine('form')}}},[_vm._v("确认")]),_c('div',{staticClass:"cancel",on:{"click":_vm.cancel}},[_vm._v("取消")])])]),_c('chooseTeam',{ref:"chooseTeam",attrs:{"cid":_vm.cid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }